import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const Container = styled.div`
  max-width: 260px;
  flex-grow: 2;
  display: flex;
  justify-content: center;
  align-items: center;

  > img {
    border-radius: 4px;
    width: 88px;
    height: 88px;
    border: 1.4px solid white;
    filter: drop-shadow(0px 2.7px 5.5px rgba(50, 50, 71, 0.2));
  }

  > div {
    height: 88px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 24px;
    font: ${props => props.theme.fontWeightMedium} 14px/100% ${props => props.theme.fontFamilyBody};
    color: ${props => props.theme.bodyColor};
    overflow: hidden;

    > * {
      display: inline !important;
      height: unset !important;
      text-align: left !important;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }

    > :not(:last-child) {
      margin-bottom: 5px;
    }

    .name {
      font-weight: ${props => props.theme.fontWeightHeavy};
      font-size: 19px;
      height: 18px !important;
    }

    .organization {
      color: #627484;
    }
  }
`;

export default function MicroProfile({
  name, profilePictureUrl, organization, position, isCompanyProfile,
}) {
  const showCompanyProfile = isCompanyProfile && !!organization;

  return (
    <Container>
      <img
        src={profilePictureUrl || window.getLivewireAssetPath('avatar-fallback.png')}
        alt={showCompanyProfile ? organization : name}
      />
      <div>
        <span className="name">{showCompanyProfile ? organization : name}</span>
        {!showCompanyProfile
          && (
          <>
            <span className="position">{position}</span>
            <span className="organization">{organization}</span>
          </>
          )}
      </div>
    </Container>
  );
}

MicroProfile.propTypes = {
  name: PropTypes.string,
  organization: PropTypes.string,
  position: PropTypes.string,
  profilePictureUrl: PropTypes.string,
  isCompanyProfile: PropTypes.bool,
};

MicroProfile.defaultProps = {
  name: '',
  organization: '',
  position: '',
  profilePictureUrl: null,
  isCompanyProfile: false,
};
